import { NetworkService } from './network-service';

const API_BASE_URL = process.env.REACT_APP_API_EXECUTION_ADDRESS;

export default class GenerationService {
    // body: { mode, instrument, prompt, sourceType, sourceId, timelineFrom, timelineTo }
    static async createGenerationAsync(projectId, body) {
        return await NetworkService.postAsync(`${API_BASE_URL}/projects/${projectId}/generations`, body);
    }

    static async listGenerationsAsync(projectId) {
        const response = await NetworkService.getAsync(`${API_BASE_URL}/projects/${projectId}/generations`);
        return response.items || response || [];
    }
}
